export default {
  testCounts: {},
  projects: [],
  timeRange: "",
};
